import {
  CopyToClipboard as CopyToClipboardBase,
  ANIMATION_DURATION_IN_MILLISECONDS,
} from './CopyToClipboard'

export const CopyToClipboard = Object.assign(CopyToClipboardBase, {
  animationDuration: ANIMATION_DURATION_IN_MILLISECONDS,
})
